module.exports = __webpack_public_path__ + "static/media/iot-application-header-bg.458917ef.jpg";